import { useCallback } from 'react';

import { generateAlias } from 'config/requests';
import { TextInputProps, useInput } from 'react-admin';
import { useWatch } from 'react-hook-form';
import { IconButton } from 'shared/mui/IconButtons';
import { GenerateTextIconStyled } from 'shared/mui/Icons';
import { Tooltip } from 'shared/mui/Tooltip/Tooltip/Tooltip';
import { Typography } from 'shared/mui/Typography';
import { TextInput } from 'shared/react-admin/Inputs';

export type TextInputWithAliasProps = {
  target?: string;
  transformValue?: (value: string) => string;
} & TextInputProps;

export function TextInputWithAlias({
  target = 'name',
  transformValue,
  ...rest
}: TextInputWithAliasProps): JSX.Element {
  const { field } = useInput({ source: rest.source });
  const targetValue = useWatch({ name: target });

  const handleClick = useCallback(async () => {
    const response = await generateAlias(
      transformValue ? transformValue(targetValue) : targetValue,
    );
    field.onChange(response.data.alias);
  }, [targetValue]);

  return (
    <TextInput
      {...rest}
      InputProps={{
        endAdornment: (
          <Tooltip title={<Typography fontSize={12}>Сгенерировать алиас</Typography>}>
            <span>
              <IconButton disabled={!targetValue} onClick={handleClick}>
                <GenerateTextIconStyled disabled={!targetValue} />
              </IconButton>
            </span>
          </Tooltip>
        ),
      }}
    />
  );
}
